const _404 = () => {
  return <div>_404</div>;
};

export default _404;
